interface PageHeroProps {
  eyebrow?: string;
  title: string;
  titleHighlight?: string;
  subtitle?: string;
  desc?: string;
  imageUrl: string;
  imageAlt: string;
  imageTitle?: string;
  children?: React.ReactNode;
}

export default function PageHero({
  eyebrow,
  title,
  titleHighlight,
  subtitle,
  desc,
  imageUrl,
  imageAlt,
  imageTitle,
  children,
}: PageHeroProps) {
  return (
    <section className="relative w-full min-h-[68vh] flex items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src={imageUrl}
          alt={imageAlt}
          title={imageTitle || imageAlt}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90"></div>
      </div>

      <div className="absolute -top-24 -left-24 w-80 h-80 md:w-96 md:h-96 rounded-full bg-primary-500/20 blur-3xl animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 md:w-[28rem] md:h-[28rem] rounded-full bg-accent-500/15 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-16 md:pb-20">
        <div className="max-w-5xl mx-auto">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {eyebrow}
              </span>
            </div>
          )}

          <h1 className="mt-5 font-heading font-bold text-background-50 leading-tight">
            <span className="block text-3xl md:text-5xl lg:text-6xl">{title}</span>
            {titleHighlight && (
              <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl text-primary-300">
                {titleHighlight}
              </span>
            )}
          </h1>

          {subtitle && (
            <p className="mt-5 text-base md:text-lg text-background-200">{subtitle}</p>
          )}

          {desc && (
            <p className="mt-3 text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl">
              {desc}
            </p>
          )}

          {children}
        </div>
      </div>
    </section>
  );
}